define('boxes/deposit-bonus/deposit-bonus-view',['jquery', 'all/jquery/jquery.mustache'], function ($) {
    'use strict';

    return {
        render: function (depositBonus) {
            $.Mustache.addFromDom('bonuses-template', parent.document.body);
            var $bonusElement = depositBonus.$box.find('.bonuses');

            $bonusElement.mustache('bonuses-template', {bonuses: depositBonus.model.bonusesData}, {method: 'html'});
        }
    };
});


